// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WorkerModalV1_modal__f8CRR {
  position: fixed;
  inset: 0;
  backdrop-filter: blur(6px);
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1050;
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;
  display: flex;
  align-items: center;
}

.WorkerModalV1_content__SCYT4 {
  width: 100%;
  height: 100%;
  background-color: #fff;
  box-shadow: 0 0 25px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
}

.WorkerModalV1_main__keBqY {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
}

.WorkerModalV1_footer__7y8uW {
  justify-content: flex-end;
  gap: 20px;
}

.WorkerModalV1_item__-F5ag {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 500px;
  border-radius: 5px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  background-color: #f1f3f5;
}

.WorkerModalV1_cardHeader__-wD\\+N {
  height: 100px;
  width: 100%;
  background-color: #868e96;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.WorkerModalV1_cardMain__G5di\\+ {
  display: flex;
  flex-direction: column;
  height: auto;
  height: 500px;
  font-weight: 400;
}
.WorkerModalV1_cardMain__G5di\\+ h2 {
  font-size: 50px;
}
.WorkerModalV1_top__\\+x08N {
  height: 40%;
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}

.WorkerModalV1_topLeft__uLoK3 {
  width: 60%;
}

.WorkerModalV1_topRight__Pz4dl {
  width: 40%;
}

.WorkerModalV1_bottom__BzG94 {
  height: 60%;
  width: 100%;
  display: flex;
  border-top: 1px solid black;
  padding-left: 20px;
  padding-right: 20px;
}

.WorkerModalV1_bottomLeft__PB-ss {
  width: 60%;
  padding-top: 10px;
}

.WorkerModalV1_bottomRight__EcRY8 {
  width: 40%;
  display: flex;
  justify-content: flex-end;
}

.WorkerModalV1_qrCont__VIneB {
  margin-top: 10px;
}

.WorkerModalV1_workerImg__3YFlJ {
  width: 150px;
  height: 200px;
  margin-left: auto;
  margin-right: auto;
  object-fit: cover;
}

.WorkerModalV1_cardFooter__mSQCB {
  display: flex;
  gap: 10px;
  background-color: #868e96;
  height: 150px;
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
  padding: 0 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: black;
}
.WorkerModalV1_cardFooter__date__s7p3I {
  margin-left: auto;
  margin-right: auto;
  font-size: 30px;
}
.WorkerModalV1_cardFooter__left__JKkoM {
  width: 100px;
  height: 100px;
}
.WorkerModalV1_cardFooter__left__JKkoM .WorkerModalV1_qr__7Q\\+5q {
  width: 150px !important;
  height: 150px !important;
}

.WorkerModalV1_mainJob__rokjb {
  font-size: 28px;
  line-height: normal;
}

.WorkerModalV1_cardFooterCode__UA4a4 {
  font-size: 30px;
}

.WorkerModalV1_studiing__UKH4H {
  display: flex;
  flex-direction: column;
  margin-left: auto;
  margin-right: auto;
}
.WorkerModalV1_studiing__block__jmejF {
  display: flex;
  align-items: center;
  gap: 20px;
  text-align: center;
}
.WorkerModalV1_studiing__block__jmejF h3 {
  display: flex;
  font-size: 35px;
  width: 80%;
  line-height: 100%;
  text-align: start;
}
.WorkerModalV1_studiing__block__jmejF span {
  font-size: 25px;
}
.WorkerModalV1_studiing__UKH4H .WorkerModalV1_fontLarge__mjhJb {
  font-size: 28px;
}
.WorkerModalV1_studiing__UKH4H .WorkerModalV1_fontSmall__ey\\+t- {
  font-size: 25px;
}`, "",{"version":3,"sources":["webpack://./src/views/workers/WorkerModalV1.module.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,QAAA;EACA,0BAAA;EACA,oCAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;AADJ;;AAIA;EAEI,WAAA;EAEA,YAAA;EACA,sBAAA;EAEA,uCAAA;EACA,aAAA;EACA,sBAAA;AAJJ;;AAQA;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AALJ;;AAQA;EACI,yBAAA;EACA,SAAA;AALJ;;AAQA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;EAEA,kBAAA;EACA,kBAAA;EACA,0CAAA;EACA,yBAAA;AANJ;;AAUA;EACI,aAAA;EACA,WAAA;EACA,yBAAA;EACA,4BAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAPJ;;AAWA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EAEA,aAAA;EACA,gBAAA;AATJ;AAaI;EACI,eAAA;AAXR;AAoBA;EACI,WAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AAlBJ;;AAqBA;EACI,UAAA;AAlBJ;;AAqBA;EACI,UAAA;AAlBJ;;AAqBA;EACI,WAAA;EACA,WAAA;EACA,aAAA;EACA,2BAAA;EACA,kBAAA;EACA,mBAAA;AAlBJ;;AAsBA;EACI,UAAA;EACA,iBAAA;AAnBJ;;AAsBA;EACI,UAAA;EACA,aAAA;EAEA,yBAAA;AApBJ;;AAuBA;EACI,gBAAA;AApBJ;;AAyBA;EAEI,YAAA;EAEA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAxBJ;;AA2BA;EACI,aAAA;EACA,SAAA;EACA,yBAAA;EACA,aAAA;EAEA,+BAAA;EACA,gCAAA;EACA,eAAA;EAGA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AA3BJ;AA6BI;EAEI,iBAAA;EACA,kBAAA;EACA,eAAA;AA5BR;AA+BI;EACI,YAAA;EACA,aAAA;AA7BR;AAgCQ;EAII,uBAAA;EACA,wBAAA;AAjCZ;;AAuCA;EAGI,eAAA;EACA,mBAAA;AAtCJ;;AA0CA;EACI,eAAA;AAvCJ;;AA2CA;EACI,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AAxCJ;AA2CI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EAEA,kBAAA;AA1CR;AA4CQ;EACI,aAAA;EAIA,eAAA;EACA,UAAA;EACA,iBAAA;EAEA,iBAAA;AA9CZ;AAkDQ;EAEI,eAAA;AAjDZ;AAqDI;EAEI,eAAA;AApDR;AAuDI;EACI,eAAA;AArDR","sourcesContent":[".modal {\n    position: fixed;\n    inset: 0;\n    backdrop-filter: blur(6px);\n    background-color: rgba(0, 0, 0, 0.4);\n    z-index: 1050;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: auto;\n\n\n    display: flex;\n    align-items: center;\n}\n\n.content {\n\n    width: 100%;\n\n    height: 100%;\n    background-color: #fff;\n\n    box-shadow: 0 0 25px rgba(0, 0, 0, 0.3);\n    display: flex;\n    flex-direction: column;\n\n}\n\n.main {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 20px;\n}\n\n.footer {\n    justify-content: flex-end;\n    gap: 20px;\n}\n\n.item {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    width: 500px;\n    // height: 750px;\n    border-radius: 5px;\n    text-align: center;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n    background-color: #f1f3f5;\n\n}\n\n.cardHeader {\n    height: 100px;\n    width: 100%;\n    background-color: #868e96;\n    border-top-left-radius: 25px;\n    border-top-right-radius: 25px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n\n.cardMain {\n    display: flex;\n    flex-direction: column;\n    height: auto;\n\n    height: 500px;\n    font-weight: 400;\n\n\n\n    h2 {\n        font-size: 50px;\n    }\n\n    &__right {\n        // font-size: clamp(30px, 5vw, 40px);\n        // font-size: 35px !important;\n    }\n}\n\n.top {\n    height: 40%;\n    width: 100%;\n    display: flex;\n    margin-bottom: 20px;\n}\n\n.topLeft {\n    width: 60%;\n}\n\n.topRight {\n    width: 40%;\n}\n\n.bottom {\n    height: 60%;\n    width: 100%;\n    display: flex;\n    border-top: 1px solid black;\n    padding-left: 20px;\n    padding-right: 20px;\n\n}\n\n.bottomLeft {\n    width: 60%;\n    padding-top: 10px;\n}\n\n.bottomRight {\n    width: 40%;\n    display: flex;\n    // justify-content: center;\n    justify-content: flex-end;\n}\n\n.qrCont {\n    margin-top: 10px;\n}\n\n\n\n.workerImg {\n    // width: 200px;\n    width: 150px;\n    // height: 250px;\n    height: 200px;\n    margin-left: auto;\n    margin-right: auto;\n    object-fit: cover;\n}\n\n.cardFooter {\n    display: flex;\n    gap: 10px;\n    background-color: #868e96;\n    height: 150px;\n    // height: 200px;\n    border-bottom-left-radius: 25px;\n    border-bottom-right-radius: 25px;\n    padding: 0 30px;\n\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    color: black;\n\n    &__date {\n        // color: white;\n        margin-left: auto;\n        margin-right: auto;\n        font-size: 30px;\n    }\n\n    &__left {\n        width: 100px;\n        height: 100px;\n        // border: 1px solid white;\n\n        .qr {\n\n            // width: 100px;\n            // height: 100px;\n            width: 150px !important;\n            height: 150px !important;\n        }\n    }\n}\n\n\n.mainJob {\n    // font-size: 45px;\n    // color: white;\n    font-size: 28px;\n    line-height: normal;\n\n}\n\n.cardFooterCode {\n    font-size: 30px;\n    // color: white;\n}\n\n.studiing {\n    display: flex;\n    flex-direction: column;\n    margin-left: auto;\n    margin-right: auto;\n\n\n    &__block {\n        display: flex;\n        align-items: center;\n        gap: 20px;\n\n        text-align: center;\n\n        h3 {\n            display: flex;\n            // justify-content: flex-start;\n            // justify-content: center;\n            // font-size: 45px;\n            font-size: 35px;\n            width: 80%;\n            line-height: 100%;\n\n            text-align: start;\n\n        }\n\n        span {\n            // font-size: 30px;\n            font-size: 25px;\n        }\n    }\n\n    .fontLarge {\n        // font-size: 35px;\n        font-size: 28px;\n    }\n\n    .fontSmall {\n        font-size: 25px;\n    }\n}\n\n\n\n\n\n\n// @media print {\n//     :global(#sizer) {\n//         // width: 100%;\n//         // height: auto;\n//         width: 148mm !important;\n//         height: 210mm !important;\n//     }\n\n//     @page {\n//         // size: 21cm 14.7cm;\n//         // size: A5 portrait;\n//         margin: 0;\n//         width: 148mm !important;\n//         height: 210mm !important;\n//     }\n\n//     //\n//     // html,\n//     // body {\n//     //     width: 100% !important;\n//     //     height: auto !important;\n//     //     overflow: visible !important;\n//     // }\n\n//     //\n\n\n//     body * {\n//         visibility: hidden;\n\n//     }\n\n//     .modal,\n//     .modal * {\n//         visibility: visible;\n\n//     }\n\n//     .modal {\n//         position: absolute !important;\n//         top: 10px;\n//         left: 10px;\n//         // width: 100% !important;\n//         // height: auto !important;\n//         // overflow: visible !important;\n//         // background: white !important;\n//         // box-shadow: none !important;\n//         // backdrop-filter: none !important;\n//         // z-index: auto !important;\n\n//         // display: flex;\n//         // align-items: center;\n//         // overflow: hidden !important;\n\n//         // top: 50%;\n//         // left: 50%;\n//         // transform: translate(-50%, -50%);\n//         // width: calc(53mm * 1.5) !important;\n//         // height: calc(85mm * 1.5) !important;\n//         // width: 100mm !important;\n//         // height: 100mm !important;\n//         transform: none !important;\n//         width: 53mm !important;\n//         height: 85mm !important;\n\n\n\n//     }\n\n//     .content {\n//         // height: auto !important;\n//         // display: flex;\n//         // align-items: center;\n//         // justify-content: center;\n//         overflow: hidden !important;\n//         width: 53mm !important;\n//         height: 85mm !important;\n//     }\n\n//     .main {\n//         overflow: hidden !important;\n//     }\n\n//     .item {\n//         // display: flex;\n//         // flex-direction: column;\n//         // border-radius: 5px;\n//         // text-align: center;\n//         width: 53mm !important;\n//         height: 85mm !important;\n\n\n//     }\n\n//     .cardHeader {\n//         // display: flex;\n//         // align-items: center;\n//         // background-color: #868e96;\n//         // justify-content: center;\n//         // align-items: flex-end;\n//         height: 12mm !important;\n\n\n//         h3 {\n//             font-size: 3mm;\n//         }\n//     }\n\n//     .top {\n//         height: 30%;\n//         // display: flex;\n\n//     }\n\n//     .bottom {\n//         height: 70%;\n//     }\n\n//     .topLeft {\n//         // display: flex;\n//         // flex-direction: column;\n//         gap: 1mm !important;\n\n//         h3 {\n//             display: block;\n//         }\n\n//     }\n\n//     .bottom {}\n\n//     .bottomLeft {\n//         // display: flex;\n//         // flex-direction: column;\n//         gap: 1mm !important;\n\n//         h3 {\n//             display: block;\n//         }\n//     }\n\n//     .cardMain {\n//         // display: flex;\n//         // flex-direction: column;\n//         height: 59.5mm !important;\n\n//         h2 {\n//             // font-size: 40px;\n//             // font-size: 30px;\n//             font-size: 6mm;\n//         }\n\n//         h3 {\n//             font-size: 3mm;\n//         }\n\n//         &__right {\n//             // font-size: 35px;\n//         }\n//     }\n\n\n\n//     .workerImg {\n//         width: 15mm;\n//         height: 15mm;\n//         margin-left: auto;\n//         margin-right: auto;\n//     }\n\n//     .cardFooter {\n//         gap: 0.1mm !important;\n//         border-bottom-left-radius: 25px;\n//         border-bottom-right-radius: 25px;\n//         padding: 0 10mm;\n//         background-color: #868e96;\n//         // display: flex;\n//         // flex-direction: column;\n//         height: 13.5mm !important;\n\n//         // align-items: flex-end;\n\n//         &__date {\n//             h3 {\n//                 // color: white;\n//                 margin-left: auto;\n//                 margin-right: auto;\n//                 font-size: 3mm;\n//                 font-size: 2.5mm;\n//                 width: 30mm;\n//             }\n//         }\n//     }\n\n//     .mainJob {\n//         // font-size: 40px;\n//         font-size: 3mm;\n//         line-height: normal;\n\n//     }\n\n//     .cardFooterCode {\n//         // margin-top: -5mm;\n//         // font-size: 20px;\n//         font-size: 3mm;\n//         font-size: 2.5mm;\n//     }\n\n//     .studiing {\n//         // display: flex;\n//         // flex-direction: column;\n//         margin-left: auto;\n//         margin-right: auto;\n\n\n//         &__block {\n//             // display: flex;\n//             // align-items: center;\n//             // gap: 20px;\n//             gap: 0.5mm !important;\n\n//             justify-content: flex-start;\n\n//             h3 {\n//                 // display: flex;\n//                 justify-content: flex-start;\n//                 width: 80%;\n//                 text-align: start;\n\n//             }\n\n//             span {\n//                 font-size: 3mm;\n//             }\n//         }\n//     }\n\n//     .fontLarge {\n//         font-size: 2.5mm !important;\n//     }\n\n//     .fontSmall {\n//         font-size: 1.5mm !important;\n//     }\n\n//     // .qr {\n//     //     width: 50px !important;\n//     //     height: 50px !important;\n//     // }\n\n//     .closeButton {\n//         display: none;\n//     }\n\n//     .printButton {\n//         display: none;\n//     }\n// }\n\n// @media print {\n//     @page {\n//         size: 148mm 210mm;\n//         margin: 0;\n//     }\n\n//     body * {\n//         visibility: hidden;\n//     }\n\n//     .item,\n//     .item * {\n//         visibility: visible;\n//     }\n\n//     .modal {\n//         // position: absolute;\n//         // left: 0;\n//         // top: 0;\n//         width: 53mm;\n//         height: 85mm;\n//     }\n\n//     .item {\n//         // position: absolute;\n//         // left: 0;\n//         // top: 0;\n//         width: 53mm;\n//         height: 85mm;\n//     }\n\n//     .modal,\n//     .content,\n//     .main {\n//         all: unset;\n//     }\n\n//     .printButton,\n//     .closeButton {\n//         display: none;\n//     }\n// }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `WorkerModalV1_modal__f8CRR`,
	"content": `WorkerModalV1_content__SCYT4`,
	"main": `WorkerModalV1_main__keBqY`,
	"footer": `WorkerModalV1_footer__7y8uW`,
	"item": `WorkerModalV1_item__-F5ag`,
	"cardHeader": `WorkerModalV1_cardHeader__-wD+N`,
	"cardMain": `WorkerModalV1_cardMain__G5di+`,
	"top": `WorkerModalV1_top__+x08N`,
	"topLeft": `WorkerModalV1_topLeft__uLoK3`,
	"topRight": `WorkerModalV1_topRight__Pz4dl`,
	"bottom": `WorkerModalV1_bottom__BzG94`,
	"bottomLeft": `WorkerModalV1_bottomLeft__PB-ss`,
	"bottomRight": `WorkerModalV1_bottomRight__EcRY8`,
	"qrCont": `WorkerModalV1_qrCont__VIneB`,
	"workerImg": `WorkerModalV1_workerImg__3YFlJ`,
	"cardFooter": `WorkerModalV1_cardFooter__mSQCB`,
	"cardFooter__date": `WorkerModalV1_cardFooter__date__s7p3I`,
	"cardFooter__left": `WorkerModalV1_cardFooter__left__JKkoM`,
	"qr": `WorkerModalV1_qr__7Q+5q`,
	"mainJob": `WorkerModalV1_mainJob__rokjb`,
	"cardFooterCode": `WorkerModalV1_cardFooterCode__UA4a4`,
	"studiing": `WorkerModalV1_studiing__UKH4H`,
	"studiing__block": `WorkerModalV1_studiing__block__jmejF`,
	"fontLarge": `WorkerModalV1_fontLarge__mjhJb`,
	"fontSmall": `WorkerModalV1_fontSmall__ey+t-`
};
export default ___CSS_LOADER_EXPORT___;
